import { useEffect } from "react";
import { experimentsNamesValues, withOnLoadFlagsAndExperiments } from "../hoc/with-flags-and-experiments";
import HeapHelpers from "helpers/heap-helpers";
import PropTypes from "prop-types";

/**
 * @component ClientExperimentLoader
 * @description This client-side component monitors the Redux state for the loading of LaunchDarkly experiment flags.
 * Once these flags are loaded into the Redux store, this component retrieves the current experiment values
 * and transmits them as custom properties within a Heap event.
 *
 * The primary goal of this component is to ensure comprehensive tracking of all active experiments within Heap
 * across the entire webpage. This centralized approach aims to mitigate issues such as missing data
 * and inconsistencies that were previously encountered by us.
 *
 * By centralizing experiment data transmission, we hypothesize that this component will eliminate instances of "No Data"
 * in Heap reporting, which we suspect may have been caused by race conditions or timing-related issues during
 * state updates and lifecycle methods in other parts of the application. This ensures more reliable and accurate
 * experiment analytics.
 */

function ClientExperimentLoader({ flagsAndExperimentsLoaded, flagsAndExperiments }) {
  useEffect(() => {
    if (flagsAndExperimentsLoaded) {
      HeapHelpers.fireHeapEvent("client_side_experiments_loaded", flagsAndExperiments);
    }
  }, [flagsAndExperimentsLoaded]);

  return;
}

ClientExperimentLoader.propTypes = {
  flagsAndExperimentsLoaded: PropTypes.bool,
  flagsAndExperiments: PropTypes.object,
};

export default withOnLoadFlagsAndExperiments(...experimentsNamesValues)(ClientExperimentLoader);
